import { IAPIRoutes } from "../../../../apiRoutes";

export type ISsoRepository = ReturnType<typeof SsoRepositoryFactory>;

export interface ISsoRefreshTokenResponse {
  id_token: string;
  access_token: string;
  refresh_token?: string;
  expires_at?: number;
}

export interface ISsoAuthPreFlightResponse {
  email: string;
}

export interface ISsoAuthPreFlightRequest {
  email: string;
}

export const SsoRepositoryFactory = ({
  APIProvider,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  APIRoutes: IAPIRoutes;
}) => {
  const { POST } = APIProvider;

  /**
   * Refresh SSO tokens using a refresh token
   * This endpoint doesn't require Authorization header since the user's token may be expired
   * @param refreshToken - The refresh token
   * @param userId - The user ID (used for both username and sub)
   */
  const refreshToken = async (
    refreshToken: string,
    userId: string,
    username: string,
    type: "pcc" | "microsoft" = "pcc"
  ): Promise<ISsoRefreshTokenResponse | null> => {
    try {
      const response = await POST(
        APIRoutes.apiSsoRefreshToken,
        {
          refresh_token: refreshToken,
          username: username,
          sub: userId,
          type: type,
        },
        {} // No auth header needed - token may be expired
      );
      return response;
    } catch (error) {
      console.error("[SsoRepository] Failed to refresh token:", error);
      return null;
    }
  };

  const authPreFlight = async (payload: ISsoAuthPreFlightRequest) => {
    return POST(APIRoutes.apiAuthPreFlight, payload);
  };

  return {
    refreshToken,
    authPreFlight,
  };
};
